const pageNameKey = "machinesListPage";

export const vpnManagerByRolePageEn = {
  [pageNameKey]: {
    title: "Machine List",
    addMachineButton: "Add Machine",
  },
};

export const vpnManagerByRolePagePtBr = {
  [pageNameKey]: {
    title: "Lista de máquinas",
    addMachineButton: "Adicionar máquina",
  },
};

export const vpnManagerByRolePageDe = {
  [pageNameKey]: {
    title: "Maschinenliste",
    addMachineButton: "Maschine hinzufügen",
  },
};

export const vpnManagerByRolePageZhHans = {
  [pageNameKey]: {
    title: "机器列表",
    addMachineButton: "添加机器",
  },
};

export const vpnManagerByRolePageIt = {
  [pageNameKey]: {
    title: "Lista macchine",
    addMachineButton: "Aggiungi macchina",
  },
};

export const vpnManagerByRolePageEs = {
  [pageNameKey]: {
    title: "Lista de máquinas",
    addMachineButton: "Agregar máquina",
  },
};

export const vpnManagerByRolePageNl = {
  [pageNameKey]: {
    title: "Machinelijst",
    addMachineButton: "Machine toevoegen",
  },
};

export const vpnManagerByRolePageTr = {
  [pageNameKey]: {
    title: "Makine Listesi",
    addMachineButton: "Makine Ekle",
  },
};
